module.exports = __webpack_public_path__ + "img/scraps.c450335d.png";